export const disabledRoles = ['CanAddOrganization', 'CanDeleteOrganization', 'CanAddQRCode', 'CanDeleteQRCode']